export const ActionTypes = {
  serviceRequestUpdate: 'Custom Event: ServiceRequestUpdate',
  clientSideProblem: 'Custom Event: ClientSideProblem',
  ServiceRequestStatusUpdate: 'Custom Event: ServiceRequestStatusUpdate',
  ServiceRequestNotesUpdate: 'Custom Event: ServiceRequestNotesUpdate',
  ServiceRequestAttachmentsUpdate: 'Custom Event: ServiceRequestAttachmentsUpdate',
  serviceCallRequestAppointmentGet: 'Custom Event: serviceCallRequestAppointmentGet',
  successfulShellImport: 'Custom Event: successfulShellImport',
  clientContextSuccess: 'Custom Event: {0}Success', // Uses the same event format for clientContext and authContext
  quickStartClick: 'Custom Event: QuickStartClick',
  createFlowDeepLinkSet: 'Custom Event: createFlowDeepLinkSet',
  serviceHealthAdminList: 'Custom Event: ServiceHealthAdminList',
  serviceHealthUpsertNoStatusDescription: 'Custom Event: UpsertNoStatusDescription',
  serviceHealthStatusList: 'Custom Event: ServiceHealthStatusList',
  preFetchDataUtilized: 'Custom Event: PreFetchDataUtilized',
  sharedConnectorRequest: 'Custom Event: SharedConnectorRequest',
  organizationRequestsViewLoad: 'Custom Event: OrganizationRequestsViewLoaded',
  invokeDeepLinkSuccess: 'Custom Event: InvokeDeepLinkSuccess',
  invokeDeepLinkError: 'Custom Event: InvokeDeepLinkError',
  invokeDeepLinkEmptyTopic: 'Custom Event: InvokeDeepLinkEmptyTopic',
};
